import Entity from '../entity'

export default class FinancialStatement extends Entity<number>{
    customer_id: number;
    currency_id: number;
    year: number;
}


